<template>
  <div>
    <nav
      class="navbar navbar-light navbar-expand-lg border-bottom px-3 fixed-top"
    >
      <router-link class="navbar-brand" to="/">
        <img
          v-if="$store.state.country == 'us'"
          src="../assets/logo_us.svg"
          class="navbar-brand-img"
          alt="Ne'eman USA logo"
        />
        <div class="logo" v-if="$store.state.country == 'can'">
          The Emunim Fund
          <span>Canada</span>
        </div>
      </router-link>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarCollapse">
        <button
          class="navbar-toggler close"
          type="button"
          data-toggle="collapse"
          data-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i class="fe fe-x"></i>
        </button>

        <ul class="navbar-nav ml-auto">
          <!-- <template v-if="$store.state.country == 'us'">
            <a
              href="#"
              class="nav-link text-primary btn-outline-primary btn btn-sm btn-pill lift ml-md-auto mb-3 mb-sm-0 d-sm-block d-lg-none"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
              @click.prevent="switchCountry"
            >
              <i class="fab fa-canadian-maple-leaf"></i>
              To Ne'eman Canada</a
            >
          </template>
          <template v-if="$store.state.country == 'can'">
            <a
              href="#"
              class="nav-link text-primary btn-outline-primary btn btn-sm btn-pill lift ml-md-auto mb-3 mb-sm-0 d-sm-block d-lg-none"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
              @click.prevent="switchCountry"
            >
              <i class="fad fa-flag-usa"></i>
              To Ne'eman USA</a
            >
          </template> -->
          <router-link
            tag="a"
            class="nav-link"
            data-toggle="collapse"
            data-target=".navbar-collapse.show"
            to="/"
            :class="[$route.name == 'Home' ? 'active' : '']"
            ><i class="fad fa-home"></i> Home
          </router-link>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              id="navbarDocumentation"
              data-toggle="dropdown"
              href="#"
              aria-haspopup="true"
              aria-expanded="false"
              :class="[$route.query.category > 0 ? 'active' : '']"
            >
              Categories <i class="fad fa-chevron-down"></i>
            </a>
            <div
              class="dropdown-menu dropdown-menu-md"
              aria-labelledby="navbarDocumentation"
            >
              <div class="list-group list-group-flush">
                <router-link
                  tag="a"
                  class="list-group-item"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                  :to="'/projects?category=' + category.id"
                  v-for="category in $store.state.categories"
                  :key="category.id"
                >
                  <div class="icon icon-sm text-primary">
                    <i :class="'fad fa-' + category.icon"></i>
                  </div>
                  <div class="ml-4">
                    <h6
                      class="font-weight-bold text-uppercase text-primary mb-0"
                    >
                      {{ category.name }}
                    </h6>
                  </div>
                </router-link>
              </div>
            </div>
          </li>

          <li class="nav-item dropdown">
            <router-link
              tag="a"
              class="nav-link"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
              to="/projects"
              :class="[
                $route.name == 'Projects' && !$route.query.category
                  ? 'active'
                  : '',
              ]"
            >
              Projects
            </router-link>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              id="navbarDocumentation"
              data-toggle="dropdown"
              href="#"
              aria-haspopup="true"
              aria-expanded="false"
              :class="[
                [
                  'About',
                  'Contact',
                  'HowToDonate',
                  'Join',
                  'services',
                ].includes($route.name)
                  ? 'active'
                  : '',
              ]"
            >
              More <i class="fad fa-chevron-down"></i>
            </a>
            <div
              class="dropdown-menu dropdown-menu-md"
              aria-labelledby="navbarDocumentation"
            >
              <div class="list-group list-group-flush">
                <router-link
                  tag="a"
                  class="list-group-item"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                  to="/about-us"
                >
                  About Us
                </router-link>
                <router-link
                  tag="a"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                  class="list-group-item"
                  to="/how-to-donate"
                >
                  How to Donate
                </router-link>
                <router-link
                  tag="a"
                  class="list-group-item"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                  to="/join-us"
                  v-if="$store.state.country == 'us'"
                >
                  Join Us
                </router-link>
                <router-link
                  tag="a"
                  class="list-group-item"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                  to="/contact"
                >
                  Contact Us
                </router-link>
                <router-link
                  v-if="$store.state.country == 'us'"
                  tag="a"
                  class="list-group-item"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                  to="/services"
                >
                  Services
                </router-link>
                <router-link
                  tag="a"
                  class="list-group-item"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                  to="/about-us-he"
                >
                  אודות קרן נאמן
                </router-link>
              </div>
            </div>
          </li>
        </ul>
        <!-- <template v-if="$store.state.country == 'us'">
          <a
            href="#"
            class="nav-link text-primary btn-outline-primary btn btn-sm btn-pill lift ml-md-auto mb-3 mb-sm-0 d-none d-sm-block"
            data-toggle="collapse"
            data-target=".navbar-collapse.show"
            @click.prevent="switchCountry"
          >
            <i class="fab fa-canadian-maple-leaf"></i>
            To The Emunim Fund Canada</a
          >
        </template>
        <template v-if="$store.state.country == 'can'">
          <a
            href="#"
            class="nav-link text-primary btn-outline-primary btn btn-sm btn-pill lift ml-md-auto mb-3 mb-sm-0 d-none d-sm-block"
            data-toggle="collapse"
            data-target=".navbar-collapse.show"
            @click.prevent="switchCountry"
          >
            <i class="fad fa-flag-usa"></i>
            To Ne'eman USA</a
          >
        </template> -->
        <a
          class="btn btn-sm btn-primary lift ml-md-5 btn-donate nav-link"
          data-toggle="collapse"
          data-target=".navbar-collapse.show"
          href="#!"
          @click.stop.prevent="
            $store.state.showDonate = !$store.state.showDonate
          "
          :style="{
            backgroundImage:
              'url(' +
              require('@/assets/img/btn_' +
                $store.state.country +
                '_flag.jpg') +
              ')',
          }"
        >
          <span>Donate Now</span>
        </a>
      </div>
    </nav>
  </div>
</template>
<script>
import { EventBus } from "../event-bus.js";
export default {
  methods: {
    switchCountry() {
      EventBus.$emit("switchCountry");
    },
    collapse() {},
  },
  computed: {},
};
</script>
<style lang="scss">
.navbar-light {
  background: #fff;
}
.navbar-brand-img {
  max-height: initial !important;
  height: 3.75rem;
}
.navbar-expand-lg .navbar-nav .nav-link {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}
.navbar-expand-sm .navbar-nav .nav-link {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}

@media (max-width: 1165px) {
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
.collapse.show {
  padding: 20px;
}
.fixed-top {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}
.navbar-collapse.show {
  transform: initial !important;
}
.navbar-collapse .navbar-toggler.close {
  position: fixed !important;
  top: 30px;
  right: 30px;
}
.logo {
  text-align: center;
  line-height: 1;
  span {
    display: block;
    font-weight: lighter;
    font-size: 1rem;
    letter-spacing: 0.4rem;
    font-family: "Source Sans Pro", sans-serif;
  }
}
</style>